import { useMutation } from "@tanstack/react-query";
import post from "@adora/shared/utils/post";
import { JsonValue } from "@adora/shared/utils/patch";
import { RelativeUrl } from "@adora/shared/utils/environment";
import type { SaveLabelsRequest, SaveLabelsResponse } from "../types/creative-eval";

export function useCreativeEvalLabels() {
  return useMutation({
    mutationFn: async (request: SaveLabelsRequest) => {
      const result = await post<SaveLabelsResponse>(
        `${RelativeUrl}/creative-eval/labels`,
        {},
        request as unknown as JsonValue
      );

      return result.match(
        (error) => {
          throw new Error(error.message);
        },
        (data) => data
      );
    }
  });
}
